import {
  ArticleGridSectionContainer,
  FilterButtonsContainer,
  FilterByButtonContainer,
  FilterByTooltipWrapper,
  FilterContainer,
  FilterPillContainer,
  PaginatorWrapper,
  SearchInputWrapper,
  SortButtonMenuWrapper,
  galleryCSS,
} from './styles/SectionFilterableArticle.styles';
import {
  FilterContentType,
  FilterList,
  FilterTime,
  IArticle,
  SectionFilterableArticleProps,
  SeoDataTypes,
  TagSubtopic,
  TagTopic,
} from './types/SectionFilterableArticles.types';
import React, { Key, useContext, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import Paginator from '@legacy-vfuk/core-paginator';
import { css } from 'styled-components';
import {
  FilterWrapper,
  CardsWrapper,
} from '../SectionFeature/styles/SectionFeatureRow.styles';
import { Button } from '@legacy-vfuk/core-button';
import { Tooltip as FilterByTooltip } from 'react-tooltip';
import {
  OverflowMenu,
  OverflowMenuItem,
} from '@legacy-vfuk/core-overflow-menu';
import { SearchInput } from '@legacy-vfuk/core-search-input';
import DrawerFilter from './DrawerFilter';
import { DirectionContext } from '../../../../contexts/DirectionContext';
import {
  checkAppliedDrawerFilters,
  checkAppliedFilters,
  updateUrlQueryParams,
  getTagNameFromValue,
  getTagsAndFiltersFromValues,
  formFilteredContent,
  getSubTopicsFromTopics,
  checkQuery,
  getSubtopicNamesFromDisplayName,
} from '../../../../helpers/articleHelpers';
import SectionArticleShelves from '../SectionArticleShelves/SectionArticleShelves';
import ArticleCardGrid from './ArticleCardGrid';
import TopicCarousel from './TopicCarousel';
import FilterableArticlesHeader from './FilterableArticlesHeader';
import { ClearFiltersLink } from './styles/DrawerFilter.styles';
import FilterPill from './FilterPill';
import Spacing from '@legacy-vfuk/core-spacing';
import { SectionDynaimcShelfProps } from '../SectionArticleShelves/types/SectionArticleShelves.types';
import RichText from '../../Elements/RichText';
import { navigate } from 'gatsby';

const MOBILE_VIEW_WIDTH = 794;

const SectionFilterableArticles = ({
  section,
  location,
  readingTimeMinuteLabel,
  displaySaveIcon,
  saveLabelText,
  saveIconClicked,
}: SectionFilterableArticleProps) => {
  const {
    slug: articleIndexSlug,
    seoTitle,
    seoDescription,
    additionalFields,
    articleShelves,
    mediaShelves,
    articleIndex,
    homePageUrl,
    uiTextNewestFilterButton,
    uiTextMostPopularFilterButton,
    uiTextAllFilterButton,
    uiTextFilterByFilterButton,
    uiTextFilterByCategories,
    uiTextFilterApplied,
    uiTextTimeFilterLabel,
    uiTextContentTypeLabel,
    uiTextCancelFilterButton,
    uiTextApplyFilterButton,
    uiTextSearchDefault,
    uiTextTopicsDropdownDefault,
    uiTextNoResults,
    uiTextNoResultsDescription,
    uiImageNoResultsFound,
    uiTextLinkClear,
    topics,
    filterTime,
    filterContentType,
    filterSeoEventData,
    mostPopularEnabled,
  } = section;

  const isMobile = checkWindowSize();

  const direction = useContext(DirectionContext);

  let desktopPageSize = 9;
  const paramsObj = new URLSearchParams(location.search);
  let recentlyViewedArticleSlugs = [];
  if (typeof window !== 'undefined' && window && window.localStorage) {
    recentlyViewedArticleSlugs = JSON.parse(
      window.localStorage.getItem('viewed-articles') || '[]'
    );
  }

  const querySearchString = paramsObj.get('query_search')
    ? decodeURIComponent(paramsObj.get('query_search'))
    : '';

    const queryTopicString = paramsObj.get('query_topic')
    ? decodeURIComponent(paramsObj.get('query_topic'))
    : '';
    
    const topicDisplayName = getTagNameFromValue(topics, queryTopicString);
    
    const querySubtopicString = paramsObj.get('query_subtopic')
    ? decodeURIComponent(paramsObj.get('query_subtopic'))
    : '';
    
    const subtopicDisplayName = getSubtopicNamesFromDisplayName(
      topics,
      querySubtopicString
    );
    
    const queryTimeRangeString = paramsObj.get('query_time_range')
    ? decodeURIComponent(paramsObj.get('query_time_range'))
    : '';
    
    const queryContentTypeString = paramsObj.get('query_content_type')
    ? decodeURIComponent(paramsObj.get('query_content_type'))
    : '';
    
    const queryPageString = paramsObj.get('query_page')
    ? decodeURIComponent(paramsObj.get('query_page'))
    : '1';
    
    const querySortString = paramsObj.get('sort')
    ? decodeURIComponent(paramsObj.get('sort'))
    : '';
    
    const queryDisplayString = paramsObj.get('display')
    ? decodeURIComponent(paramsObj.get('display'))
    : '';
    
    const queryShelfString = paramsObj.get('shelf')
    ? decodeURIComponent(paramsObj.get('shelf'))
    : '';
    
    const sortByMostPopular = mostPopularEnabled
    ? checkQuery(querySortString, 'most_popular')
    : false;

  const sortByLatest = checkQuery(querySortString, 'latest');

  const sortByDefault = checkQuery(querySortString, 'default');

  const displayRecentlyViewed = checkQuery(
    queryDisplayString,
    'recently_viewed'
  );

  const formPagedContent = (data: any[], isMobile: boolean) => {
    let pagedData = data.reduce((resultArray, item, index) => {
      if (isMobile) {
        desktopPageSize = 3;
      }
      const pageIndex = Math.floor(index / desktopPageSize);

      if (!resultArray[pageIndex]) {
        // start new page
        resultArray[pageIndex] = [];
      }
      resultArray[pageIndex].push(item);
      return resultArray;
    }, []);

    if (pagedData.length === 0) {
      pagedData = [[]];
    }
    return pagedData;
  };

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [isSortOpen, setIsSortOpen] = useState(false);

  const [selectedSortItem, setSelectedSortItem] = useState('');

  const handleSelectSortItem = (selectedItem: string) => {
    if (selectedItem === 'latest') {
      onLatestClick();
    } else if (selectedItem === 'most_popular') {
      onMostPopularClick();
    } else {
      onAllButtonClick();
    }
  };

  useEffect(() => {
    if (isFilterOpen) {
      document.body.classList.add('disable-scrolling');
      return;
    }
    document.body.classList.remove('disable-scrolling');
  }, [isFilterOpen]);

  const [recentlyViewedShelfArticles, setRecentlyViewedShelfArticles] =
    useState([]);

  const [
    recentlyViewedShelfMediaArticles,
    setRecentlyViewedShelfMediaArticles,
  ] = useState([]);

  const [updatedTimeFilters, setUpdatedTimeFilters] = useState(filterTime);

  const updateFilterTime = (timeFilterList: FilterTime[]) => {
    const updatedTimeFilterList: FilterTime[] = [];
    const initialArticles = ContentfulSectionFilterableArticleIndex.articles;
    const currentTime = new Date();
    if (timeFilterList && timeFilterList.length > 0) {
      timeFilterList.forEach(timeFilter => {
        const foundArticle = initialArticles.find(article => {
          const timeThreshold =
            currentTime.getTime() - timeFilter.timeRangeInMinutes * 60 * 1000;
          const articleTime = new Date(article.publishingDate).getTime();
          return articleTime >= timeThreshold;
        });
        if (foundArticle) {
          updatedTimeFilterList.push(timeFilter);
        }
      });
    }
    return updatedTimeFilterList;
  };

  const getSortButtonText = () => {
    if (filterList.latest) {
      return additionalFields.uiTextSortByButtonLabel.replace(
        '{sortType}',
        uiTextNewestFilterButton
      );
    } else if (filterList.mostPopular) {
      return additionalFields.uiTextSortByButtonLabel.replace(
        '{sortType}',
        uiTextMostPopularFilterButton
      );
    } else {
      return additionalFields.uiTextSortByButtonLabel.replace(
        '{sortType}',
        uiTextAllFilterButton
      );
    }
  };

  const setupRecentlyViewedArticleShelf = () => {
    const allArticles = ContentfulSectionFilterableArticleIndex.articles;
    const recentlyViewedArticles = recentlyViewedArticleSlugs
      .slice(0, 4)
      .map((slug: string) => allArticles.find(article => article.slug === slug))
      .filter((article: IArticle | undefined) => article !== undefined);
    setRecentlyViewedShelfArticles(recentlyViewedArticles);
  };

  const setupRecentlyViewedMediaShelf = () => {
    const allArticles = ContentfulSectionFilterableArticleIndex.articles.filter(
      (article: IArticle) => {
        return article.contentType?.isMedia === true;
      }
    );
    const recentlyViewedMediaArticles = recentlyViewedArticleSlugs
      .map((slug: string) => allArticles.find(article => article.slug === slug))
      .filter((article: IArticle | undefined) => article !== undefined)
      .slice(0, 4);
    setRecentlyViewedShelfMediaArticles(recentlyViewedMediaArticles);
  };

  useEffect(() => {
    articles.current = ContentfulSectionFilterableArticleIndex.articles;
    setUpdatedTimeFilters(updateFilterTime(filterTime));
    setupRecentlyViewedArticleShelf();
    setupRecentlyViewedMediaShelf();
  }, []);

  const onRecentlyViewed = () => {
    if (filterList.recentlyViewed) {
      return;
    }

    setSeoData({
      event_type: 'recently_viewed',
      filter_query: 'recently_viewed',
    });

    setFilterList(prevFilterList => ({
      ...prevFilterList,
      page: 0,
      recentlyViewed: true,
    }));
  };

  const onMediaClick = () => {
    if (filterList.media) {
      return;
    }

    setSeoData({
      event_type: 'media',
      filter_query: 'media',
    });

    navigate('?shelf=media', {
      state: {
        action: 'filterChange',
        data: window.location.href,
      },
    });
  };

  const onLatestClick = () => {
    if (filterList.latest) {
      return;
    }

    setSelectedSortItem('latest');

    setSeoData({
      event_type: 'latest',
      filter_query: 'latest',
    });

    setFilterList(prevFilterList => ({
      ...prevFilterList,
      mostPopular: false,
      latest: true,
      default: false,
      page: 0,
    }));
  };

  const onMostPopularClick = () => {
    if (filterList.mostPopular) {
      return;
    }

    setSelectedSortItem('most_popular');

    setSeoData({
      event_type: 'most_popular',
      filter_query: 'most_popular',
    });

    setFilterList(prevFilterState => ({
      ...prevFilterState,
      latest: false,
      default: false,
      mostPopular: true,
      page: 0,
    }));
  };

  const onSubtopicAllClick = (subtopicSlug: string) => {
    let allSubtopics: TagSubtopic[] = [];
    topics.forEach(tagTopic => {
      if (tagTopic.subtopics) {
        allSubtopics = allSubtopics.concat(tagTopic.subtopics);
      }
    });
    const selectedSubtopic = allSubtopics.find(subtopic => {
      return subtopic.slugName === subtopicSlug;
    });

    if (!selectedSubtopic) {
      return;
    }

    const newSelectedSubTopics = [selectedSubtopic];

    const newSubTopic = selectedSubtopic.displayName;

    const newSubTopicValue = selectedSubtopic.slugName;
    const newFilterList: FilterList = {
      ...filterList,
      subtopic: newSubTopic,
      subtopicValue: newSubTopicValue,
      selectedSubtopics: newSelectedSubTopics,
      page: 0,
    };

    setSeoData({
      event_type: 'subtopic',
      filter_query: newSubTopicValue,
    });

    setFilterList(newFilterList);
  };

  const [seoData, setSeoData] = useState<any>({});

  const [page, setPage] = useState(
    queryPageString ? Number(queryPageString) - 1 : 0
  );

  const [filterList, setFilterList] = useState<FilterList>({
    topic: topicDisplayName,
    topicValue: queryTopicString,
    selectedTopics: getTagsAndFiltersFromValues(
      topics,
      queryTopicString.split(',')
    ),
    subtopic: subtopicDisplayName,
    subtopicValue: querySubtopicString,
    selectedSubtopics: getTagsAndFiltersFromValues(
      getSubTopicsFromTopics(topics),
      querySubtopicString.split(',')
    ),
    latest: sortByLatest,
    page: page,
    default: sortByDefault,
    mostPopular: sortByMostPopular,
    recentlyViewed: displayRecentlyViewed,
    media: checkQuery(queryShelfString, 'media'),
    timeRange: getTagsAndFiltersFromValues(
      updatedTimeFilters,
      queryTimeRangeString.split(',')
    ),
    contentType: getTagsAndFiltersFromValues(
      filterContentType,
      queryContentTypeString.split(', ')
    ),
  });

  const [searchQuery, setSearchQuery] = useState(querySearchString);
  const [searchText, setSearchText] = useState(querySearchString);

  const [filtersApplied, setFiltersApplied] = useState(false);

  const [drawerFiltersApplied, setDrawerFiltersApplied] = useState(0);

  const [isMediaView, setIsMediaView] = useState(false);

  const [{ content: contentData }] = articleIndex;
  const [{ content }] = contentData;
  const [ContentfulSectionFilterableArticleIndex] = content;

  ContentfulSectionFilterableArticleIndex.articles =
    ContentfulSectionFilterableArticleIndex.articles.filter(
      (article, index, self) =>
        index === self.findIndex(a => a.id === article.id)
    );
  // The unfiltered articles. Note that the articles are rendered on hydration, so
  // articles is populated on the useEffect(() => {}, []).
  const articles = useRef([]);
  // The filtered article list (i.e. after any queries and
  // filters are applied.
  const filteredArticles = formFilteredContent(
    articles.current,
    filterList,
    searchQuery,
    recentlyViewedArticleSlugs
  );

  // Paged version of filteredArticles.
  const [pagedArticles, setPagedArticles] = useState(
    formPagedContent(filteredArticles, isMobile)
  );
  // The article list as a view.
  const currentPageContent: IArticle[] = pagedArticles[page] || [];

  const onTopicCarouselFilter = (topicSlug: string) => {
    const selectedTopic = topics.find(topic => topic.slugName == topicSlug);
    if (!selectedTopic) {
      return;
    }

    const exsitingTopic = filterList.selectedTopics.find(
      topic => topic.slugName === selectedTopic.slugName
    );

    if (exsitingTopic) {
      const newSelectedTopics = filterList.selectedTopics.filter(
        topic => topic.slugName !== selectedTopic.slugName
      );

      const newTopic = newSelectedTopics
        .map(topic => topic.displayName)
        .join(',');

      const newTopicValue = newSelectedTopics
        .map(topic => topic.slugName)
        .join(',');

      const newFilterList: FilterList = {
        ...filterList,
        subtopic: '',
        subtopicValue: '',
        selectedSubtopics: [],
        topic: newTopic,
        topicValue: newTopicValue,
        selectedTopics: newSelectedTopics,
        contentType: [],
        timeRange: [],
        latest: false,
        mostPopular: false,
        recentlyViewed: false,
        default: false,
        media: false,
        page: 0,
      };
      setFilterList(newFilterList);
    } else {
      const newSelectedTopics = [selectedTopic];

      const newTopic = newSelectedTopics
        .map(topic => topic.displayName)
        .join(',');

      const newTopicValue = newSelectedTopics
        .map(topic => topic.slugName)
        .join(',');

      const newFilterList: FilterList = {
        ...filterList,
        subtopic: '',
        subtopicValue: '',
        selectedSubtopics: [],
        topic: newTopic,
        topicValue: newTopicValue,
        selectedTopics: newSelectedTopics,
        contentType: [],
        timeRange: [],
        latest: false,
        mostPopular: false,
        recentlyViewed: false,
        default: false,
        media: false,
        page: 0,
      };

      setSeoData({
        event_type: 'topic',
        filter_query: selectedTopic.slugName,
      });

      setFilterList(newFilterList);
    }
  };

  const onAllTopicsClick = () => {
    setSeoData({
      event_type: 'all',
      filter_query: 'all',
    });

    setFilterList(prevFilterList => ({
      topic: '',
      topicValue: '',
      selectedTopics: [],
      subtopic: '',
      subtopicValue: '',
      selectedSubtopics: [],
      contentType: [],
      timeRange: [],
      latest: false,
      mostPopular: false,
      recentlyViewed: false,
      default: !prevFilterList.default,
      media: false,
      page: 0,
    }));
  };

  const onSeeAllCickedHandler = (type: string, subtopicSlug?: string) => {
    window.scrollTo(0, 0);
    switch (type) {
      case 'latest':
        onLatestClick();
        break;
      case 'recently-viewed':
        onRecentlyViewed();
        break;
      case 'media':
        onMediaClick();
        break;
      case 'subtopic':
        subtopicSlug && onSubtopicAllClick(subtopicSlug);
        break;
      default:
        break;
    }
  };

  function onFilterChange() {
    const currentPage = page + 1;

    updateUrlQueryParams('query_topic', filterList.topicValue);

    updateUrlQueryParams('query_subtopic', filterList.subtopicValue);

    if (filterList.latest) {
      updateUrlQueryParams('sort', 'latest');
    } else if (filterList.mostPopular) {
      updateUrlQueryParams('sort', 'most_popular');
    } else if (filterList.recentlyViewed) {
      updateUrlQueryParams('display', 'recently_viewed');
    } else if (filterList.media) {
      updateUrlQueryParams('shelf', 'media');
    } else if (filterList.default) {
      updateUrlQueryParams('sort', 'default');
    } else {
      updateUrlQueryParams('sort', '');
      updateUrlQueryParams('display', '');
      updateUrlQueryParams('shelf', '');
    }

    const timeRanges = filterList.timeRange
      .map(time => time.slugName)
      .join(',');

    updateUrlQueryParams('query_time_range', timeRanges);

    const contentTypes = filterList.contentType
      .map(contentTypeFilter => contentTypeFilter.slugName)
      .join(',');

    updateUrlQueryParams('query_content_type', contentTypes);

    updateUrlQueryParams('query_page', filterList.page + 1, currentPage === 1);

    if (currentPage !== 1 && currentPage !== filterList.page) {
      setPage(filterList.page);
    }
  }

  useEffect(() => {
    updateUrlQueryParams('query_search', searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    onFilterChange();
    setFiltersApplied(checkAppliedFilters(filterList, searchQuery));
    setDrawerFiltersApplied(checkAppliedDrawerFilters(filterList));
    setIsMediaView(filterList.media);
  }, [filterList, searchQuery]);

  useEffect(() => {
    if (
      topicDisplayName === filterList.topic &&
      subtopicDisplayName === filterList.subtopic &&
      Number(queryPageString) === page
    ) {
      return;
    }

    const newFilter: FilterList = {
      ...filterList,
      topic: topicDisplayName,
      topicValue: queryTopicString,
      subtopic: subtopicDisplayName,
      subtopicValue: querySubtopicString,
      page: queryPageString ? Number(queryPageString) - 1 : 0,
      media: checkQuery(queryShelfString, 'media'),
    };
    if (Number(queryPageString) !== page) {
      setPage(newFilter.page);
    }

    setFilterList(newFilter);
  }, [location.search]);

  function checkWindowSize() {
    const [isMobile, setIsMobile] = useState(false);
    if (typeof window !== 'undefined') {
      useEffect(() => {
        function handleResize() {
          if (window.innerWidth <= MOBILE_VIEW_WIDTH) {
            setIsMobile(true);
          }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    }
    return isMobile;
  }

  useEffect(() => {
    const newFilter = { ...filterList, page: page };
    setFilterList(newFilter);
  }, [page]);

  const firePaginatorClickEvent = (targetValue: number) => {
    try {
      // fire the utag link event
      if (window.onPaginatorClickEvent) {
        window.onPaginatorClickEvent(targetValue);
      }
    } catch (e) {
      console.log(
        'onPaginatorClickEvent failed - please check the Page Changing Arrows Script'
      );
    }
  };

  const changePage = (newPage: number) => {
    firePaginatorClickEvent(newPage);
    setPage(newPage - 1);
    window.scrollTo(0, 0);
  };

  const runFilterEventData = (sData: SeoDataTypes) => {
    const filterEventData = filterSeoEventData.filterSeoEventData;

    if (window.onFilterUserEvent && filterEventData) {
      try {
        const payload = JSON.parse(filterEventData);
        const { type, data } = payload;

        // Fire the filterUserEvent
        window.onFilterUserEvent(type, { ...data, ...sData });
      } catch (e) {
        console.log(
          'onFilterUserEvent failed - please check the Filter SEO script JSON and that a SeoInteractionScript is correctly set up.'
        );
      }
    }
  };

  const onSearch = () => {
    setSeoData({
      event_type: 'search',
      search_terms: searchText,
    });

    setSearchQuery(searchText);
    setPage(0);
  };

  const onSearchClear = () => {
    setSearchText('');
    setSearchQuery('');
  };

  useEffect(() => {
    const results = formFilteredContent(
      articles.current,
      filterList,
      searchQuery,
      recentlyViewedArticleSlugs
    );

    setPagedArticles(formPagedContent(results, isMobile));

    // SEO Tracking is allowed for the opco.
    runFilterEventData({
      ...seoData,
      search_results_count: results.length,
    });
  }, [searchQuery, filterList, seoData]);

  const isFiltersReset = (): boolean => {
    const ignoreKeys = ['page'] as const satisfies Array<keyof FilterList>;
    type RelevantInResetFilterListKeys = Exclude<
      keyof FilterList,
      (typeof ignoreKeys)[number]
    >;

    const filterListKeys: RelevantInResetFilterListKeys[] = Object.keys(
      filterList
    ).filter(
      (key): key is RelevantInResetFilterListKeys =>
        !ignoreKeys.includes(key as never)
    );

    return (
      filterListKeys.every(key => {
        const filterListValue = filterList[key];

        if (Array.isArray(filterListValue)) {
          return filterListValue.length < 1;
        }

        return !filterListValue;
      }) && searchQuery === ''
    );
  };

  const clearFilterState = (toMediaShelf: boolean) => {
    setSearchQuery('');
    setSearchText('');

    const clearFilterValues: FilterList = {
      topic: '',
      topicValue: '',
      selectedTopics: [],
      subtopic: '',
      subtopicValue: '',
      selectedSubtopics: [],
      contentType: [],
      timeRange: [],
      latest: false,
      mostPopular: false,
      recentlyViewed: false,
      default: false,
      media: toMediaShelf,
      page: 0,
    };

    setFilterList(prevFilterList => ({
      ...prevFilterList,
      ...clearFilterValues,
    }));

    setSeoData({
      event_type: 'clear',
      filter_query: '',
    });
  };

  const onClearAll = (toMediaShelf: boolean) => {
    if (isFiltersReset()) {
      return;
    }
    setSelectedSortItem('');
    clearFilterState(toMediaShelf);
  };

  const onAllButtonClick = () => {
    if (filterList.default) {
      return;
    }

    setSelectedSortItem('all');

    setSeoData({
      event_type: 'default',
      filter_query: 'default',
    });

    setFilterList(prevFilterState => ({
      ...prevFilterState,
      mostPopular: false,
      latest: false,
      default: true,
      page: 0,
    }));
  };

  const generateSubtopicShelves = (topic: TagTopic) => {
    const topicShelves = [];
    if (topic.featuredArticles) {
      topicShelves.push(topic.featuredArticles);
    }
    if (topic.subtopics) {
      topic.subtopics?.map(subtopic => {
        topicShelves.push({
          id: subtopic.id,
          __typename: 'ContentfulSectionDynamicShelf',
          name: subtopic.name,
          displayName: subtopic.displayName,
          seeAllLabel: subtopic.seeAllLabel,
          type: 'subtopic',
          subtopicSlug: subtopic.slugName,
        } as SectionDynaimcShelfProps);
      });
    }
    return topicShelves;
  };

  const removeSubtopicFromFilterList = (subtopicTarget: TagSubtopic) => {
    setFilterList(prevFilterList => {
      const newSubtopic = prevFilterList.subtopic
        .split(',')
        .filter(subtopic => subtopic !== subtopicTarget.displayName)
        .join(',');

      const newSubtopicValue = prevFilterList.subtopicValue
        .split(',')
        .filter(subtopic => subtopic !== subtopicTarget.slugName)
        .join(',');

      const newSelectedSubtopics = prevFilterList.selectedSubtopics.filter(
        subtopic => subtopic.slugName !== subtopicTarget.slugName
      );

      return {
        ...prevFilterList,
        subtopic: newSubtopic,
        subtopicValue: newSubtopicValue,
        selectedSubtopics: newSelectedSubtopics,
      };
    });
  };

  const removeTimeFilterFromFilterList = (timeFilterTarget: FilterTime) => {
    setFilterList(prevFilterList => {
      const newTimeRange = prevFilterList.timeRange.filter(
        time => time.slugName !== timeFilterTarget.slugName
      );
      return {
        ...prevFilterList,
        timeRange: newTimeRange,
      };
    });
  };

  const removeContentTypeFromFilterList = (
    timeFilterTarget: FilterContentType
  ) => {
    setFilterList(prevFilterList => {
      const newTimeRange = prevFilterList.contentType.filter(
        contentType => contentType.slugName !== timeFilterTarget.slugName
      );
      return {
        ...prevFilterList,
        contentType: newTimeRange,
      };
    });
  };

  const calculatePlaceholderWidth = (placeholderDefaultLength = 200) => {
    const placeHolderLength = uiTextSearchDefault.length;
    let placeHolderPixelWidth =
      placeHolderLength * 5 + placeholderDefaultLength;
    placeHolderPixelWidth =
      placeHolderPixelWidth < 250 ? 250 : placeHolderPixelWidth;
    return placeHolderPixelWidth + 'px';
  };

  return (
    <>
      <Helmet>
        {seoTitle.trim().length > 0 && <title>{seoTitle}</title>}
        {seoDescription.trim().length > 0 && (
          <meta name="description" content={seoDescription} />
        )}
      </Helmet>
      <div className="spring custom-spring">
        <CardsWrapper css={galleryCSS}>
          {additionalFields && (
            <FilterableArticlesHeader
              filterList={filterList}
              additionalFields={additionalFields}
              filtersApplied={filtersApplied}
              isMediaView={isMediaView}
              searchQuery={searchQuery}
              direction={direction}
            />
          )}
          {topics && isMediaView === false && (
            <TopicCarousel
              forYouLabel={additionalFields?.uiTextForYouTopicLabel}
              allLabel={additionalFields?.uiTextAllTopicLabel}
              savedLabel={additionalFields?.uiTextSavedTopicLabel}
              topics={topics}
              selectedTopics={filterList.selectedTopics}
              handleForYouClicked={saveIconClicked}
              handleTopicFiltered={topicSlug => {
                onTopicCarouselFilter(topicSlug);
              }}
              handleAllTopicsClick={onAllTopicsClick}
              allFilterSelected={
                filterList.selectedTopics.length < 1 &&
                (filterList.default ||
                  filterList.mostPopular ||
                  filterList.latest)
              }
            />
          )}
        </CardsWrapper>

        <FilterWrapper css={galleryCSS}>
          <FilterContainer>
            <SearchInputWrapper
              direction={direction}
              inputWidth={calculatePlaceholderWidth(300)}
              isSingle={false}
            >
              <SearchInput
                textInput={{
                  id: 'search',
                  value: searchText,
                  onChange: e => setSearchText(e.target.value),
                  placeholder: uiTextSearchDefault,
                }}
                fieldWrapper={{
                  showLabel: false,
                  label: '',
                  width: 'full',
                }}
                searchIconButton={{ onClick: onSearch }}
                onClear={onSearchClear}
              />
            </SearchInputWrapper>
            <FilterButtonsContainer>
              {additionalFields && (
                <SortButtonMenuWrapper>
                  <Button
                    text={getSortButtonText()}
                    icon={{ name: 'sort', justify: 'right' }}
                    appearance="alt1"
                    onClick={() => setIsSortOpen(!isSortOpen)}
                  />
                  <OverflowMenu
                    isOpen={isSortOpen}
                    activeItem={selectedSortItem}
                    onChange={handleSelectSortItem}
                    onClose={() => setIsSortOpen(false)}
                    srText={additionalFields.uiTextSortByButtonLabel.replace(
                      '{sortType}',
                      ''
                    )}
                    onOutsideClick={() => setIsSortOpen(false)}
                  >
                    <OverflowMenuItem
                      value="latest"
                      text={uiTextNewestFilterButton}
                    />
                    <OverflowMenuItem
                      value="most_popular"
                      disabled={!mostPopularEnabled}
                      text={uiTextMostPopularFilterButton}
                    />
                    <OverflowMenuItem
                      value="all"
                      text={uiTextAllFilterButton}
                    />
                  </OverflowMenu>
                </SortButtonMenuWrapper>
              )}
              <FilterByButtonContainer
                direction={direction}
                filtersApplied={drawerFiltersApplied}
              >
                {additionalFields && additionalFields.uiTextFilterTooltip ? (
                  <FilterByTooltipWrapper>
                    <FilterByTooltip
                      id="filter-button-tooltip"
                      anchorSelect="#filter-by-button"
                      place="bottom"
                    >
                      <RichText
                        text={additionalFields.uiTextFilterTooltip}
                        textAlign={'center'}
                      />
                    </FilterByTooltip>
                    <Button
                      text={
                        drawerFiltersApplied > 0
                          ? additionalFields &&
                            additionalFields.uiTextAppliedFiltersButton
                          : uiTextFilterByFilterButton
                      }
                      icon={{ name: 'filter', justify: 'right' }}
                      appearance="alt1"
                      onClick={() => setIsFilterOpen(true)}
                      id="filter-by-button"
                    />
                  </FilterByTooltipWrapper>
                ) : (
                  <Button
                    text={
                      drawerFiltersApplied > 0
                        ? additionalFields &&
                          additionalFields.uiTextAppliedFiltersButton
                        : uiTextFilterByFilterButton
                    }
                    icon={{ name: 'filter', justify: 'right' }}
                    appearance="alt1"
                    onClick={() => setIsFilterOpen(true)}
                  />
                )}
              </FilterByButtonContainer>
            </FilterButtonsContainer>

            <DrawerFilter
              key={isFilterOpen as unknown as Key}
              isOpen={isFilterOpen}
              setIsOpen={setIsFilterOpen}
              tagTopics={topics}
              filterTime={updatedTimeFilters}
              filterContentype={filterContentType}
              filterList={filterList}
              setFilterList={setFilterList}
              uiTextLinkClear={uiTextLinkClear}
              uiTextFilterByCategories={uiTextFilterByCategories}
              uiTextFilterApplied={uiTextFilterApplied}
              uiTextContentTypeLabel={uiTextContentTypeLabel}
              uiTextTimeFilterLabel={uiTextTimeFilterLabel}
              checkboxDefaultLabel={uiTextTopicsDropdownDefault}
              uiTextCancelFilterButton={uiTextCancelFilterButton}
              uiTextApplyFilterButton={uiTextApplyFilterButton}
              setSeoData={setSeoData}
            />
          </FilterContainer>

          {filterList.contentType.length > 0 ||
            filterList.timeRange.length > 0 ||
            (filterList.selectedSubtopics.length > 0 && (
              <Spacing spacingLevel={{ top: 4 }}>
                <FilterPillContainer>
                  {filterList.contentType.map(contentType => (
                    <FilterPill
                      key={contentType.name}
                      item={contentType}
                      removeItemFromFilterList={removeContentTypeFromFilterList}
                    />
                  ))}
                  {filterList.timeRange.map(time => (
                    <FilterPill
                      item={time}
                      key={time.name}
                      removeItemFromFilterList={removeTimeFilterFromFilterList}
                    />
                  ))}
                  {filterList.selectedSubtopics.map(subtopic => (
                    <FilterPill
                      item={subtopic}
                      key={subtopic.name}
                      removeItemFromFilterList={removeSubtopicFromFilterList}
                    />
                  ))}

                  <ClearFiltersLink onClick={() => onClearAll(false)}>
                    {uiTextLinkClear}
                  </ClearFiltersLink>
                </FilterPillContainer>
              </Spacing>
            ))}
        </FilterWrapper>
      </div>
      <div
        css={css`
          display: ${filtersApplied || isMediaView ? 'none' : 'block'};
        `}
      >
        <SectionArticleShelves
          direction={direction}
          articleShelves={articleShelves}
          articles={ContentfulSectionFilterableArticleIndex.articles}
          recentlyViewedArticles={recentlyViewedShelfArticles}
          mostPopularEnabled={mostPopularEnabled}
          readingTimeMinuteLabel={readingTimeMinuteLabel}
          displaySaveIcon={displaySaveIcon}
          saveLabelText={saveLabelText}
          seoTitle={seoTitle}
          articleIndexSlug={articleIndexSlug}
          handleSaveClick={saveIconClicked}
          handleSeeAllClick={onSeeAllCickedHandler}
        />
      </div>
      <div
        css={css`
          display: ${!filtersApplied && isMediaView ? 'block' : 'none'};
        `}
      >
        <SectionArticleShelves
          direction={direction}
          articleShelves={mediaShelves}
          articles={ContentfulSectionFilterableArticleIndex.articles.filter(
            article => {
              return article.contentType?.isMedia === true;
            }
          )}
          recentlyViewedArticles={recentlyViewedShelfMediaArticles}
          mostPopularEnabled={mostPopularEnabled}
          readingTimeMinuteLabel={readingTimeMinuteLabel}
          displaySaveIcon={displaySaveIcon}
          saveLabelText={saveLabelText}
          seoTitle={seoTitle}
          articleIndexSlug={articleIndexSlug}
          handleSaveClick={saveIconClicked}
          handleSeeAllClick={onSeeAllCickedHandler}
        />
      </div>
      {filterList.selectedTopics.length > 0 &&
        filterList.selectedSubtopics.length < 1 &&
        !filterList.mostPopular &&
        !filterList.latest && (
          <SectionArticleShelves
            direction={direction}
            articleShelves={generateSubtopicShelves(
              filterList.selectedTopics[0]
            )}
            articles={ContentfulSectionFilterableArticleIndex.articles}
            recentlyViewedArticles={recentlyViewedShelfArticles}
            mostPopularEnabled={mostPopularEnabled}
            readingTimeMinuteLabel={readingTimeMinuteLabel}
            displaySaveIcon={displaySaveIcon}
            saveLabelText={saveLabelText}
            seoTitle={seoTitle}
            articleIndexSlug={articleIndexSlug}
            handleSaveClick={saveIconClicked}
            handleSeeAllClick={onSeeAllCickedHandler}
          />
        )}
      <ArticleGridSectionContainer
        css={
          filtersApplied &&
          (filterList.selectedSubtopics.length > 0 ||
            !filterList.selectedTopics[0]?.subtopics ||
            filterList.selectedTopics[0]?.subtopics.length < 1 ||
            filterList.latest ||
            filterList.mostPopular)
            ? css`
                background-color: var(--gallery);
              `
            : css`
                display: none;
              `
        }
        className="spring custom-spring"
      >
        {/* Article index grid */}
        <div>
          <ArticleCardGrid
            articles={currentPageContent}
            articleCardProps={{
              indexSlug: articleIndexSlug,
              backgroundColor: 'white',
              seoTitle: seoTitle,
              appliedFilters: seoData,
              queryCategories: filterList.topic.split(','),
              readingTimeMinuteLabel: readingTimeMinuteLabel,
              displaySaveIcon: displaySaveIcon,
              saveLabelText: saveLabelText,
              handleSaveClick: saveIconClicked,
              isAnimated: true,
            }}
            noResultData={{
              uiImageNoResultsFound,
              uiTextNoResults,
              uiTextNoResultsDescription,
            }}
          />
        </div>

        {pagedArticles.length > 0 && (
          <PaginatorWrapper
            isSecondLanguageOn={homePageUrl !== '/' && homePageUrl !== null}
            activeIndex={page + 1}
            data-testid="pagination"
          >
            <Paginator
              id="the-paginator"
              numberOfPages={pagedArticles.length}
              currentPage={page + 1}
              onClick={changePage}
            />
          </PaginatorWrapper>
        )}
      </ArticleGridSectionContainer>
    </>
  );
};

export default SectionFilterableArticles;
